
import { PaymentIcons } from '@payment'

export default {
  components: {
    PaymentIcons,
  },
  props: { text: { type: String, required: true } },
}
